export default "__VITE_ASSET__D8th_YLn__"